import React, { useState } from "react";
import TextInput from "../../../components/TextInput";
import SearchButton from "../../../components/SearchButton";
import RefreshButton from "../../../components/RefreshButton";

const TableFilters = ({
  filterText,
  moduleDetails,
  textInputName,
  disabledButton,
}) => {
  const [inputValue, setInputValue] = useState("");

  const FilterData = () => {
    filterText(inputValue);
  };
  const DoNothing = () => {};
  return (
    <div>
      <div className="flex flex-row space-x-2">
        {/* <label className="block font-medium text-gray-700 mb-2">
                  {moduleDetails}
                </label> */}
        <TextInput
          type={textInputName}
          name={textInputName}
          value={inputValue}
          placeholder={moduleDetails}
          onChange={(e) => {
            setInputValue(e.target.value);
            e.target.value === "" ? filterText("") : DoNothing();
          }}
        />
        {/* <div className="flex justify-center items-end gap-x-2 mb-12  lg:ml-4 md:ml-1 rounded-md mt-5"> */}
        <SearchButton
          buttonValue="Search"
          className={
            inputValue === "" || disabledButton ? "opacity-50" : "opacity-100"
          }
          disabled={inputValue === "" || disabledButton ? true : false}
          onClick={() => {
            FilterData();
          }}
        />
        <div>
          <RefreshButton
            className={
              inputValue === "" || disabledButton ? "opacity-50" : "opacity-100"
            }
            disabled={inputValue === "" || disabledButton ? true : false}
            onClick={() => {
              if (!disabledButton) {
                filterText("");
                setInputValue("");
              }
            }}
          />
        </div>
        {/* </div> */}
        {/* <Disclosure as="div" className="mt-2">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex justify-between w-full px-4 py-2 text-sm font-medium text-left text-primary bg-gray-100 rounded-t-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                <span>By {moduleDetails} Details</span>
                <ChevronDownIcon
                  className={`${
                    open ? "transform rotate-180" : ""
                  } w-5 h-5 text-gray-500`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                
              </Disclosure.Panel>
            </>
          )}
        </Disclosure> */}
      </div>
    </div>
  );
};

export default TableFilters;
